import { render, staticRenderFns } from "./WhatsappIntegracoes.vue?vue&type=template&id=03037e45&scoped=true&"
import script from "./WhatsappIntegracoes.vue?vue&type=script&lang=js&"
export * from "./WhatsappIntegracoes.vue?vue&type=script&lang=js&"
import style0 from "./WhatsappIntegracoes.vue?vue&type=style&index=0&id=03037e45&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03037e45",
  null
  
)

export default component.exports